import { api } from '@/helpers/api'

const URLS = {
    xhr: {
        fetch: {
            getEvent: '/api/events'
        }
    }
}
export const useDirectBookingEventData = () => {
    async function fetchOpportunityInfo(id) {
        const data = await api({
            method: 'get',
            url: `${URLS.xhr.fetch.getEvent}/${id}/event-top-info`
        })
        return data.data
    }

    return { fetchOpportunityInfo }
}
